import React from 'react'

const CreateProjectSpinner = () => {
    return (
        <div class="spinner">
            <div class="bar1"></div>
            <div class="bar2"></div>
            <div class="bar3"></div>
            <div class="bar4"></div>
            <div class="bar5"></div>
            <div class="bar6"></div>
            <div class="bar7"></div>
            <div class="bar8"></div>
        </div>
      );
}

export default CreateProjectSpinner